import { useMemo, useState } from "react";
import "./things-to-do.scss";
import { Typography } from "antd";

const { Title, Text } = Typography;

export default function ExpandableRichTextHtml({ html = "" }) {
  const [expanded, setExpanded] = useState(false);

  const collapsedHtml = useMemo(() => {
    const parser = new DOMParser();

    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      img.remove();
    });

    return doc.body.innerHTML;
  }, [html]);

  return (
    <div>
      <div
        className={`rich-text ${!expanded ? "rich-text-clamp" : ""}`}
        dangerouslySetInnerHTML={{
          __html: expanded ? html : collapsedHtml,
        }}
      />

      <div style={{ marginTop: 3 }}>
        <Text
          style={{ color: "#1890ff", cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            setExpanded((e) => !e)
          }}
        >
          {expanded ? "Show less" : "Show more"}
        </Text>
      </div>
    </div>
  );
}
